<template>
    <div>
        <config-main-title>
            Alçadas de Autorização de OC
        </config-main-title>

        <az-empty-state v-if="!dados || !dados.length" msg="Nenhum autorizante identificado." />

        <ul class="list-group" v-else>
            <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in dados" :key="idx">
                <div>
                    {{ item.pessoa.st_nome }}
                    <div class="small text-muted">{{ item.st_login }}</div>
                </div>
                <div class="text-right">
                    <a href="#" @click.prevent="definir_alcada(item)" class="card-link">
                        <span v-if="item.dc_alcada_oc || item.dc_alcada_oc === 0">
                            {{ $util.formatMoeda(item.dc_alcada_oc) }}
                        </span>
                        <span v-else>
                            Não definida.
                        </span>
                    </a>
                    <div>
                        <i class="fa-solid fa-shield-halved mr-2" v-if="item.fl_oc_parcial" title="Aprovação parcial"></i>

                        <span v-if="item.filtros && item.filtros.length" class="badge badge-secondary" title="Filtros">
                            <i class="fa-solid fa-filter"></i>
                            {{ item.filtros.length }}
                        </span>
                    </div>
                </div>
            </li>
        </ul>

        <!-- Modal -->
        <div class="modal fade" id="alcadaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Alçada</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">{{ edicao.pessoa.st_nome }}</p>

                        <az-input
                            type="money"
                            label="Alçada"
                            required
                            :validate="validate"
                            v-model="edicao.dc_alcada_oc">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">R$</span>
                                </div>
                            </template>
                        </az-input>

                        <div class="form-row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="checkbox-group"
                                    label="Aprovação Parcial"
                                    v-model="edicao.fl_oc_parcial" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="checkbox-group"
                                    label="Aprovação Apenas Pós Parcial"
                                    :edicao="!edicao.fl_oc_parcial"
                                    v-model="edicao.fl_oc_final" />
                            </div>
                        </div>

                        <filtro-model class="mt-3" :validate="validate" v-model="edicao.filtros" :opcoes="lista_opcoes_filtro" />
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';

export default {
    data() { 
        return { 
            dados: null, 
            edicao: null, 
            validate: false, 
        };
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState,
        AzSubmit,
        AzInput, 
        FiltroModel, 
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\fornecedor', search:'Fornecedor', service: 'fornecedores.index'},
                {id:'App\\azure\\estoqueGrupo', search:'Grupo de Item de Estoque', service: 'estoque_grupos.index'},
                {id:'App\\azure\\estoqueItem', search:'Item de Estoque', service: 'estoque_items.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        }
    },

    methods: { 
        definir_alcada (usuario) { 
            this.edicao = null;
            this.validate = false;

            this.$nextTick(() => { 
                this.edicao = _.cloneDeep(usuario);
    
                $('#alcadaModal').modal('show');
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'estoque',
                func: 'alcadas',
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'salvar_alcada',
                dados: this.edicao,
                modal: 'alcadaModal',
                toast: true, 
                reload: true, 
            });
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Alçadas de Autorização de Ordem de Compra", path: "/suprimentos/alcadas" }
        ]);

        this.load();
    }
}
</script>